
import forumEnums from '../../store/models/forumEnums'

const statuses = {

    getClass: (status) => {
        switch(status) {
            case forumEnums.topicStatusEnum.DELETED: return 'topic-deleted';
            case forumEnums.topicStatusEnum.PENDINGAPPROVAL: return 'topic-pending'
            case forumEnums.topicStatusEnum.LOCKED: 
            case forumEnums.topicStatusEnum.NORMAL:               
            case forumEnums.topicStatusEnum.MODERATED: 
              return 'topic-normal'              
            default:
              return 'topic-normal';
          }  
    }

}


export default statuses;